import React from "react";
import styled from "styled-components";

export const SectionWrapper = styled.section`
  background: #9c6;
  padding: 16px;
  margin: 0;
  border: 1px solid #ccc;
  line-height: 20px;
  text-align: center;
  .header {
    margin: 0;
    padding: 0 0 5px;
    font-size: 16px;
    color: #5a5a5a;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 18px;
  }
`;
const Section = (props) => (
  <SectionWrapper {...props}>
    <div className="header">{props.title}</div>
    <div className="sectionBody">{props.children}</div>
  </SectionWrapper>
);

export default Section;
